export default __webpack_public_path__ + "315e5f41ec0fdd78b691c1dbf7c6e2f9.png";